import React from "react";

const TermsOfService: React.FC = () => {
  return (
    <div className="beat-container max-w-3xl mx-auto">
      <div className="beat-card p-8 rounded-lg">
        <h1 className="text-3xl font-bold text-newspaper-900 mb-4">Terms of Service</h1>
        <p className="text-newspaper-600 mb-6">Last updated: December 2, 2025</p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Acceptance of Terms</h2>
        <p className="text-newspaper-700 mb-4">
          By accessing or using Beatpost, you agree to these Terms. If you do not agree, do not use the platform.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Accounts</h2>
        <p className="text-newspaper-700 mb-4">
          You must provide accurate information and keep your account secure. You are responsible for activity under
          your account.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">User Content</h2>
        <p className="text-newspaper-700 mb-4">
          You retain rights to content you submit. By publishing, you grant Beatpost a non-exclusive license to host,
          display, and distribute your content to operate the service.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Prohibited Conduct</h2>
        <ul className="list-disc pl-6 text-newspaper-700 mb-4">
          <li>Illegal, hateful, or harassing content.</li>
          <li>Spam, manipulation, or attempts to game rankings.</li>
          <li>Infringing, deceptive, or malicious activities.</li>
        </ul>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Intellectual Property</h2>
        <p className="text-newspaper-700 mb-4">
          Beatpost trademarks, logos, and software are protected. Do not copy or misuse the platform’s code or branding.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Termination</h2>
        <p className="text-newspaper-700 mb-4">
          We may suspend or terminate accounts that violate these Terms or harm the platform or users.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Disclaimers</h2>
        <p className="text-newspaper-700 mb-4">
          Beatpost is provided “as is.” We do not guarantee uninterrupted service or that content will meet your
          expectations.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Limitation of Liability</h2>
        <p className="text-newspaper-700 mb-4">
          To the extent permitted by law, Beatpost will not be liable for indirect, incidental, or consequential
          damages arising from your use of the platform.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Governing Law</h2>
        <p className="text-newspaper-700 mb-4">These Terms are governed by applicable law based on our place of operation.</p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Changes</h2>
        <p className="text-newspaper-700 mb-4">
          We may update these Terms. Material changes will be indicated by updating the “Last updated” date.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Contact</h2>
        <p className="text-newspaper-700">For questions about these Terms, contact us via the Contact page.</p>
      </div>
    </div>
  );
};

export default TermsOfService;

